import { useState } from "react";
import useToast from "../use-toast/index";
import api from "@/services/api/admin/termClause";

const toastType = {
	error: 'error'
}
const useTermClause = ({page, pageSize, sortConfig} = {}) => {
	const [termClause, setTermClause] = useState();
	const {toastList, addToastMessage} = useToast();

	const [termClauseList, setTermClauseList] = useState([]);
    const [termClauseListMeta, setTermClauseListMeta] = useState(null);
    const [paginationData, setPaginationData] = useState({page: page ?? 1, pageSize: pageSize ?? 10});

	const [termClauseLoading, setTermClauseLoading] = useState(false);
	const [sort, setSort] = useState(sortConfig);

    const fetchTermClauseList = async (params) => {
		setTermClauseLoading(true);
		const [error, data] = await api.getAllTermClause({...paginationData, ...sort, ...params});
		setTermClauseLoading(false);

		if (error) {
			addToastMessage(error?.message ?? "Failed to get model term list", toastType.error);
		}

		setTermClauseList(data?.items);
        setTermClauseListMeta(data?.meta);
	};

	const getTermClause = async (id) => {

		setTermClauseLoading(true);
		const [error, data] = await api.getTermClause(id);
		
		if (error) {
			addToastMessage(error?.message ?? "Failed to get model term list", toastType.error);
		}
		setTermClause(data);
		setTermClauseLoading(false);
	};


	const deleteTermClause = async (id) => {
		setTermClauseLoading(true);
		const [error, data] = await api.deleteTermClause(id);
		setTermClauseLoading(false);

		if (error) {
			return addToastMessage(error?.message ?? "Unable to delete model term", toastType.error);
		}
		return data;
	};

	const updateTermClauseName = async (id, params) => {
		const [error, data] = await api.updateTermClauseName(id, params);
		if (error) {
			return addToastMessage(error?.message ?? "Failed to update model term", toastType.error);
		}
		return data;
	};

	const createTermClause = async (params) => {
		setTermClauseLoading(true);
		const [error, data] = await api.createTermClause(params);
		setTermClauseLoading(false);

		if (error) {
			return addToastMessage(error?.message ?? "Failed to create model term", toastType.error);
		}
		return data;
	};


	const updateTermClause = async (id, params) => {
		setTermClauseLoading(true);
		const [error, data] = await api.updateTermClause(id, params);
		setTermClauseLoading(false);

		if (error) {
			addToastMessage(error?.message ?? "Failed to update model term", toastType.error);
		}
		return data;
	}
 
    const onPageChange = (page, orgId) => {
        if(page !== paginationData.page) {
            setPaginationData({ ...paginationData, page });
            fetchTermClauseList({ page, orgId });
        }
    }

    const onPageSizeChange = (pageSize, orgId) => {
        if(pageSize !== paginationData.pageSize) {
            setPaginationData({ ...paginationData, pageSize });
            fetchTermClauseList({ pageSize: pageSize, orgId });
        }
    }

    const onPrevious = (orgId) => {
        if(termClauseListMeta.currentPage > 1) {
            let cp = termClauseListMeta.currentPage - 1;
            setPaginationData({ ...paginationData, page: cp });
            fetchTermClauseList({ page: cp, orgId });
        }
    }

    const onNext = (orgId) => {
        if(termClauseListMeta.currentPage < termClauseListMeta.pageCount) {
            let cp = termClauseListMeta.currentPage + 1;
            setPaginationData({ ...paginationData, page: cp });
            fetchTermClauseList({ page: cp, orgId });
        }
    }

	return {
		termClause,
		termClauseList,
		termClauseLoading,
        termClauseListMeta,
        paginationData,
		toastList,
		sort,
		fetchTermClauseList,
		deleteTermClause,
		updateTermClauseName,
		createTermClause,
		getTermClause,
		updateTermClause,
        onPageChange,
        onPageSizeChange,
        onPrevious,
        onNext,
		setSort
	};
};

export default useTermClause;
